import { FatInvestorsPageListFirmsQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { advisorColumns } from '../../constants';
import AdvisorMobileSumFooter from './advisorMobileSumFooter';

interface MobileTableAdvisorProps {
  listAdvisers: FatInvestorsPageListFirmsQuery['listFirms'];
  changeViewBy: (view: string) => void;
}

const MobileTableAdvisor = ({ listAdvisers, changeViewBy }: MobileTableAdvisorProps) => {
  const TableRow = ({ el }: { el: FatInvestorsPageListFirmsQuery['listFirms']['data'][number] }) => {
    return (
      <MobileTableRowWrap>
        <MobileRow>
          <MobileRowTitle>{advisorColumns[0].title}</MobileRowTitle>
          <MobileRowValue isRedirect onClick={() => changeViewBy(el.id)}>
            {el.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{advisorColumns[1].title}</MobileRowTitle>
          <MobileRowValue>{el.investorCount}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{advisorColumns[2].title}</MobileRowTitle>
          <MobileRowValue>{el.investmentCount}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{advisorColumns[3].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip>{el.totalValue}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
        <MobileRow>
          <MobileRowTitle>{advisorColumns[4].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip>{el.totalCommitments}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {listAdvisers.data.length ? (
        <>
          {listAdvisers.data.map((el) => (
            <TableRow el={el} key={el.id} />
          ))}
          <AdvisorMobileSumFooter columns={advisorColumns} totals={listAdvisers.totals} />
        </>
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTableAdvisor;
